/**
 * Created by matthias on 02.10.15.
 */
require('./angular-ui-select');
//require('ui-select');
require('./kovResourcePicker.scss');

let m = angular.module('kovResourcePickerComponentModule', ['ui.select', 'ng-sri-client']);
m.directive('includeHtml', [
  '$compile',
  ($compile) => {
    return {
      require: '^kovResourcePicker',
      scope: {
        html: '=',
        resource: '=item',
        search: '=',
      },
      link: (scope, $element) => {
        $element.html(scope.html);
        $compile($element.contents())(scope);
        scope.$watch('html', (newVal, oldVal) => {
          if (!oldVal && newVal) {
            $element.html(newVal);
            $compile($element.contents())(scope);
          }
        });
      },
    };
  },
]);
m.component( 'kovResourcePicker', require( './kovResourcePicker.js' ) );

module.exports = 'kovResourcePickerComponentModule';